<template>
    <EmptyState v-if="areTournamentsEmpty"/>
    <div v-else>
        <div class="favourites__competition-section">
            <SportOfferEventGrid
                v-bind="scrollRelatedProps"
                class="offer__container"
                :events="tournamentsEvents"
                :areMarketsShownOutside="false"
                @oddClick="onOddClick"
                @eventGridRender="onEventGridRender"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { isEmpty as _isEmpty } from '@lodash';
    import { ExpandedEventInUrl } from '@app/enums';
    import { SelectionType } from '@models/shared/betSlip/betSlipEnums';
    import Helpers from '@store/modules/ui/shared/betSlip/Helpers';
    import SportOfferEventGrid from '../../sharedSubmodules/SportOfferEventGrid';
    import EmptyState from './components/EmptyState';

    export default {
        name: 'FavouritesContainer',
        data() {
            return {
                filterChangeIndicator: 0,
                renderedGrid: false,
            };
        },
        watch: {
            timeFilter() {
                this.filterChangeIndicator = (this.filterChangeIndicator + 1) % 3;
            },
            expandedEventId(newValue, oldValue) {
                this.performActionOnToggleExpandedEvent(oldValue);

                const eventId = this.expandedEventId;
                const match = this.eventsMap[eventId];

                if (match) {
                    if (match.containsFullOddList()) {
                        this.addEventFromUrlToBetSlip(match);
                    } else {
                        const unwatch = this.$watch(
                            () => this.eventsMap[eventId].containsFullOddList(),
                            function () {
                                this.addEventFromUrlToBetSlip(this.eventsMap[eventId]);
                                unwatch();
                            }
                        );
                    }
                }
            },
        },
        computed: {
            ...mapGetters('ui/user/preferences', [
                'tournaments',
                'tournamentsEvents',
            ]),
            ...mapGetters('data/sportOffer', [
                'isOfferFetched',
                'isSuperOfferFetched',
                'areTopTenEventsFetched',
            ]),
            ...mapGetters('ui/sportOffer', [
                'expandedEventId'
            ]),
            ...mapGetters('data/sportOffer', [
                'eventsMap',
            ]),
            areTournamentsEmpty() {
                return !this.tournaments.length || !this.tournamentsEvents.length;
            },
            scrollRelatedProps() {
                return {
                    areEventsLoaded: this.areEventsLoaded,
                    sidebarChangedState: false,
                    renderDone: this.renderedGrid,
                    filterChangeIndicator: this.filterChangeIndicator,
                };
            },
            areEventsLoaded() {
                return this.isOfferFetched
                    && this.isSuperOfferFetched
                    && this.areTopTenEventsFetched;
            },
        },
        methods: {
            ...mapActions('ui/sportOffer/betSlip', [
                'toggleAddRemoveSelection',
            ]),
            ...mapActions('ui/sportOffer', [
                'toggleExpandedEventSubscription',
            ]),
            onOddClick({ eventId, odd }) {
                const { id: oddId, specialBetValue } = odd;
                this.toggleAddRemoveSelection({ eventId, oddId, specialBetValue });
            },
            onEventGridRender() {
                this.renderedGrid = true;
            },
            performActionOnToggleExpandedEvent(oldEventId) {
                const eventId = this.expandedEventId;

                this.toggleExpandedEventSubscription({
                    eventId,
                    oldEventId,
                });
            },
            addEventFromUrlToBetSlip(match) {
                if (!match) {
                    return;
                }

                const {
                    [ExpandedEventInUrl.odd]: oddId,
                    [ExpandedEventInUrl.sbValue]: specialBetValue = ''
                } = this.$route.query;

                if (oddId) {
                    const selection = Helpers.findSelectionByEventId(this.selections, match.id, SelectionType.sport);

                    if (selection && selection.getOddId().toString() === oddId
                        && _isEmpty(selection.getOddSpecialBetValue()) === _isEmpty(specialBetValue)) {
                        return;
                    }

                    this.toggleAddRemoveSelection({
                        eventId: match.id,
                        oddId: parseInt(oddId, 10),
                        specialBetValue,
                    });
                }
            },
        },
        components: {
            EmptyState,
            SportOfferEventGrid,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/sportOffer/favourites/content/FavouritesOfferContainer.vue